<avi-data-grid
    [config]="significanceGridConfig"
    [rows]="significantLog | logSignificanceReasons"
></avi-data-grid>
<ng-template
    #significanceFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        class="log-significance__row"
        *ngIf="row.description"
        aviTitle="{{ row.description }}"
        logPartialSelectionFilter
        [noSearchIcon]="true"
        property="significance"
        [value]="row.label"
        (onFilterAdd)="onFilterAdd.emit()"
    ></span>
    <span
        class="log-significance__row"
        *ngIf="!row.description"
        logPartialSelectionFilter
        property="significance"
        [noSearchIcon]="true"
        [value]="row.label"
        (onFilterAdd)="onFilterAdd.emit()"
    ></span>
</ng-template>
